export default __webpack_public_path__ + "static/media/arrow_next_icon.0319758e.svg";